import React from 'react';
import { PropTypes } from 'prop-types';
import Carousel from 'react-material-ui-carousel';
import { Box } from '@mui/material';

import GoodyBagCardContainer from 'app/containers/GoodyBagCardContainer';

const SeekerForYouGoodyBags = ({ itemsPerSlide, goodySlides, currentUser }) => {
  if (goodySlides.length === 0) return null;

  return (
    <Carousel
      navButtonsAlwaysVisible
      cycleNavigation={false}
      animation="slide"
      indicators={false}
      autoPlay={false}
      navButtonsProps={{ style: { zIndex: 1, opacity: 0.5, margin: 1 } }}
    >
      {goodySlides.map((group) => (
        <Box
          key={`carousel_${itemsPerSlide}_slide_${group[0].id}}`}
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-start',
            paddingLeft: '16px',
            '@media (max-width:1299px)': {
              justifyContent: 'center',
              paddingLeft: '0px',
            },
          }}
        >
          {group.map((goodyBag) => (
            <Box
              key={`goodyBag_${goodyBag.id}`}
              sx={{
                width: '330px',
                flex: '0 0 330px',
              }}
            >
              <GoodyBagCardContainer
                goodyBag={goodyBag}
                viewingSelf={false}
                currentUser={currentUser}
                advisorLoading={false}
                selected={false}
                viewingSingleAdvisor={false}
                titleIsLink
              />
            </Box>
          ))}
        </Box>
      ))}
    </Carousel>
  );
};

SeekerForYouGoodyBags.defaultProps = {
  goodySlides: [],
};

SeekerForYouGoodyBags.propTypes = {
  itemsPerSlide: PropTypes.number.isRequired,
  currentUser: PropTypes.object.isRequired,
  goodySlides: PropTypes.array,
};

export default SeekerForYouGoodyBags;
